import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
const failedSolutions = ['dejar el pan unos días', 'tomar té "para desinflamar"', 'comer menos', 'hacer "detox"', 'saltarte la cena "para compensar"'];
export function PainSection() {
  return <section className="w-full bg-[#1B4332] py-20 md:py-28 px-4" data-id="element-73">
      <div className="max-w-3xl mx-auto" data-id="element-74">
        <motion.div {...fadeInUp} data-id="element-75">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#FAF3E0] text-center mb-12 leading-tight" data-id="element-76">
            "No estás fallando.
            <br data-id="element-77" />
            <span className="italic font-normal" data-id="element-78">Estás adivinando."</span>
          </h2>
        </motion.div>

        <motion.div {...fadeInUp} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-12" data-id="element-79">
          <p className="text-[#FAF3E0]/90 text-lg md:text-xl leading-relaxed mb-6" data-id="element-80">
            Si has probado:
          </p>

          <ul className="space-y-4 mb-8" data-id="element-81">
            {failedSolutions.map((solution, index) => <motion.li key={index} className="flex items-start gap-3 text-[#FAF3E0]/80 text-lg" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1 * index
          }} data-id="element-82">
                <XCircleIcon className="w-6 h-6 text-[#C75B39] flex-shrink-0 mt-0.5" data-id="element-83" />
                <span data-id="element-84">{solution}…</span>
              </motion.li>)}
          </ul>

          <p className="text-[#FAF3E0] text-lg md:text-xl leading-relaxed" data-id="element-85">
            y aun así terminas inflada al final del día…{' '}
            <strong data-id="element-86">no es porque seas floja.</strong>
          </p>
        </motion.div>

        <motion.div {...fadeInUp} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#FAF3E0]/10 rounded-2xl p-8 mb-12" data-id="element-87">
          <p className="text-[#FAF3E0] text-xl md:text-2xl leading-relaxed font-medium" data-id="element-88">
            Es porque nadie te dio un sistema.
          </p>
          <p className="text-[#FAF3E0]/80 text-lg mt-4 leading-relaxed" data-id="element-89">
            Te dieron consejos sueltos.
          </p>
          <p className="text-[#FAF3E0]/80 text-lg mt-4 leading-relaxed" data-id="element-90">
            Y con la hinchazón, los consejos sueltos se vuelven un juego cruel:
            hoy funciona, mañana no, y tú quedas con la culpa.
          </p>
        </motion.div>

        <motion.div {...fadeInUp} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="border-l-4 border-[#C75B39] pl-6" data-id="element-91">
          <h3 className="text-2xl md:text-3xl font-bold text-[#FAF3E0] mb-6" data-id="element-92">
            La hinchazón tiene una característica que vuelve loca a cualquiera:
          </h3>
          <p className="text-[#A7C4A0] text-xl md:text-2xl font-medium italic mb-6" data-id="element-93">
            te cambia el cuerpo en horas.
          </p>
          <div className="space-y-3 text-[#FAF3E0]/80 text-lg" data-id="element-94">
            <p data-id="element-95">Por eso se siente tan personal.</p>
            <p data-id="element-96">Por eso te quita seguridad.</p>
            <p data-id="element-97">Por eso te hace evitar fotos.</p>
            <p data-id="element-98">
              Por eso te hace pensar:{' '}
              <em data-id="element-99">"¿para qué me esfuerzo si igual me veo peor en la tarde?"</em>
            </p>
          </div>
        </motion.div>

        <motion.div {...fadeInUp} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-100">
          <p className="text-[#FAF3E0] text-xl md:text-2xl leading-relaxed" data-id="element-101">
            Y por eso este producto{' '}
            <strong data-id="element-102">no está diseñado para "bajar de peso".</strong>
          </p>
          <p className="text-[#A7C4A0] text-xl md:text-2xl font-medium mt-4" data-id="element-103">
            Está diseñado para bajar volumen y para que entiendas tus detonantes
            sin vivir restringida.
          </p>
        </motion.div>
      </div>
    </section>;
}